// extracted by mini-css-extract-plugin
module.exports = {"template_list":"ErrorLog_template_list__3IrTb"};